module.exports = __webpack_public_path__ + "img/scheme1.969f1604.png";